import { Injectable, OnInit } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { CasService } from "../services/auth/cas-service";
import { User } from "../models/user";

@Injectable()
export class AuthGuardCAS implements CanActivate, OnInit {
  constructor(private router: Router, private cas: CasService) {
  }

  public async ngOnInit() {
    this.cas.subscribeForTokenChange(async () => {
      await this.canActivate();
    });
    await this.canActivate();
  }

  public async canActivate() {
    const searchParameters = this.cas.getSearchParameters();
    const error = searchParameters.error;

    if (error) {
      await this.cas.logout("/login?error=" + error);
      return false;
    }
    const authenticationCode = searchParameters.code;
    if (!this.cas.isAnyTokenPresent() && authenticationCode) {
      try {
        await this.cas.accessToken(authenticationCode).toPromise();
        const data = await this.cas.queryAdditionalUserInformation().toPromise();
        const isAllowedToAccess = data.roles.indexOf("BPA") > -1;
        if (!isAllowedToAccess) {
          await this.cas.logout("/login?error=bpa.no.rights");
          return false;
        }
        return true;
      } catch (e) {
        console.error("canActivate failed, not allowing access");
        await this.cas.logout("/login");
        return false;
      }
    }

    if (!this.cas.isAnyTokenPresent()) {
      await this.cas.logout("/login");
      return false;
    }

    if (this.cas.savedTokenHasExpired()) {
      const tokenRefreshed = await this.cas.refreshToken();
      if (!tokenRefreshed) { return false; }
    }

    if (this.cas.isSavedTokenValid()) {
      return true;
    }

    return true;
  }
}
